import React, { FunctionComponent } from "react";
import styles from "./Downloads.module.scss";
import DownloadsContent from "./DownloadsContent.model";

import combineClasses from "helpers/combine-classes";
import Download from "./components/Download/Download";
import DynamicHeading from "components/DynamicHeading/DynamicHeading";
import formatDynamicTextColor from "blocks/helpers/formatDynamicTextColor";
import getProcessedRichtext from "blocks/helpers/getProcessedRichtext";
import getWrapperStyles from "blocks/helpers/getWrapperStyles";

const Downloads: FunctionComponent<DownloadsContent> = (props) => {
    const processedHeadline = getProcessedRichtext(formatDynamicTextColor(props.content.headline));
    const processedBodyText = getProcessedRichtext(props.content.bodyText);
    const wrapperStyles = getWrapperStyles(props.settings);

    return (
        <section className={combineClasses([styles.wrapper, ...wrapperStyles])}>
            <div className={styles.container}>
                {/* Intro */}
                {props.content.headline || processedBodyText ? (
                    <div className={styles.intro}>
                        {/* Headline */}
                        <DynamicHeading
                            className={styles.headline}
                            headlineSize={props.content.headlineSize}
                            headlineWeight={props.content.headlineWeight}
                            innerHtml={processedHeadline}
                        ></DynamicHeading>

                        {/* Body Text */}
                        {processedBodyText ? (
                            <div
                                className={styles.text}
                                dangerouslySetInnerHTML={processedBodyText}
                            ></div>
                        ) : null}
                    </div>
                ) : null}

                {/* Downloads */}
                {props.content.downloads && props.content.downloads.length > 0 ? (
                    <div className={styles.grid}>
                        {props.content.downloads.map((item) => {
                            return (
                                <Download
                                    key={item.contentUdi}
                                    {...item}
                                />
                            );
                        })}
                    </div>
                ) : null}
            </div>
        </section>
    );
};

export default Downloads;
